/**
 * 쿠키 설정 재오픈 진입점
 *
 * GDPR 은 동의 철회를 동의만큼 쉽게 만들 것을 요구한다. 배너는 한 번 닫히면 다시 안 뜨므로
 * 푸터 등에서 언제든 환경설정을 열 수 있는 통로가 필요하다.
 *
 * 우선순위: Shopify 자체 배너의 환경설정 모달 → (없으면) 커스텀 <cookie-consent> 배너.
 * `[data-cookie-preferences]` 또는 `<a href="#cookie-preferences">` 를 클릭하면 열린다.
 */

if (!window.openCookiePreferences) {

  window.openCookiePreferences = function () {
    // Shopify 쿠키 배너가 실려 있으면 그쪽이 정본 UI 다
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return true;
    }

    // 폴백: 테마 커스텀 배너
    const custom = document.querySelector('cookie-consent');
    if (!custom) return false;

    if (typeof custom.openPreferences === 'function') {
      custom.openPreferences();
      return true;
    }

    // 엘리먼트는 있는데 아직 업그레이드 전이다(cookie-consent.js 가 defer 로 늦게 실행).
    // 링크가 조용히 죽지 않도록 정의된 뒤 한 번 더 연다.
    if (window.customElements && typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('cookie-consent').then(() => {
        if (typeof custom.openPreferences === 'function') custom.openPreferences();
      });
      return true;
    }

    return false;
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const trigger = target.closest('[data-cookie-preferences], a[href="#cookie-preferences"]');
    if (!trigger) return;

    event.preventDefault();
    window.openCookiePreferences();
  });

}
